import { Card, CardContent, Grid } from '@mui/material';
import './card.css';
import WarningIcon from '@mui/icons-material/Warning';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { IErrorCard } from './IErrorCard';

export default function CustomisedErrorCard({ titleList }: IErrorCard) {
    return (
        <Card style={{ minHeight: 'fit-content', width: '100%' }} className="!shadow-none !bg-[transparent]">
            <p className="anjomanRegular primaryErrorColorLight  pb-2 pr-2" >
                <WarningIcon />
                خطاها
            </p>
            <CardContent className="errorCardDesign cardCantent">
                <Grid container xs={12} style={{ height: '100%' }}>
                    <Grid
                        item
                        xs={12}
                        style={{
                            height: '49%',
                            alignContent: 'center',
                            paddingTop: '10px',
                            paddingBottom: '5px',
                        }}
                    >
                        <Grid item xs={12} className="anjomanRegular">
                            <Grid container xs={12}>
                                {titleList?.map((item: any, key: number) => (
                                    <>
                                        <Grid container xs={12}>
                                            <Grid item xs={12}>
                                                <Grid container xs={12}>
                                                    <Grid item xs={0.6}>
                                                        <FiberManualRecordIcon
                                                            style={{
                                                                width: '12px',
                                                                height: '12px',
                                                            }}
                                                            className="primaryErrorColorLight"
                                                        />
                                                    </Grid>
                                                    <Grid item xs={11.4} style={{ paddingTop: '0.2vh' }}>
                                                        {item}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12}>
                                                {key + 1 < titleList.length ? (
                                                    <hr
                                                        className="hrRequest"
                                                        style={{
                                                            marginTop: '0.5vh',
                                                            marginBottom: '1vh',
                                                        }}
                                                    />
                                                ) : (
                                                    ''
                                                )}
                                            </Grid>
                                        </Grid>
                                    </>
                                ))}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}
